
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMusicNote = props => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  viewBox: "0 0 17 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m15.966 2.282-7.5-2.25A.75.75 0 0 0 7.5.75V10.9A4.5 4.5 0 1 0 9 14.25V6.258l6.534 1.96A.75.75 0 0 0 16.5 7.5V3a.75.75 0 0 0-.534-.718ZM4.5 17.25a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM15 6.492l-6-1.8V1.758l6 1.804v2.93Z",
  fill: "var(--fill-0, white)"
})));

      const __svgRaw = "<svg preserveAspectRatio=\"none\" width=\"100%\" height=\"100%\" overflow=\"visible\"  viewBox=\"0 0 17 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path id=\"Vector\" d=\"M15.9656 2.28166L8.46563 0.0316646C8.35365 -0.00194745 8.23537 -0.00891641 8.12022 0.0113142C8.00507 0.0315447 7.89625 0.0784145 7.80244 0.148182C7.70862 0.217949 7.63242 0.308682 7.57991 0.413138C7.5274 0.517593 7.50003 0.632878 7.5 0.74979V10.8992C6.73191 10.2122 5.7513 9.8096 4.72206 9.75875C3.69282 9.7079 2.6773 10.0118 1.84523 10.6198C1.01317 11.2277 0.414965 12.1028 0.150601 13.0988C-0.113763 14.0949 -0.028269 15.1514 0.392794 16.092C0.813857 17.0325 1.54498 17.8001 2.46396 18.2663C3.38295 18.7326 4.43412 18.8693 5.4418 18.6536C6.44948 18.4379 7.3526 17.883 8.00024 17.0814C8.64789 16.2798 9.0008 15.2803 9 14.2498V6.2576L15.5344 8.21792C15.6464 8.25153 15.7646 8.2585 15.8798 8.23826C15.9949 8.21803 16.1038 8.17116 16.1976 8.1014C16.2914 8.03163 16.3676 7.9409 16.4201 7.83644C16.4726 7.73199 16.5 7.6167 16.5 7.49979V2.99979C16.5 2.83855 16.448 2.68162 16.3517 2.55227C16.2554 2.42291 16.1201 2.32802 15.9656 2.28166ZM4.5 17.2498C3.90666 17.2498 3.32664 17.0738 2.83329 16.7442C2.33994 16.4146 1.95543 15.946 1.72836 15.3978C1.5013 14.8497 1.44189 14.2465 1.55765 13.6645C1.6734 13.0826 1.95912 12.548 2.37868 12.1285C2.79824 11.7089 3.33279 11.4232 3.91473 11.3074C4.49667 11.1917 5.09987 11.2511 5.64805 11.4782C6.19623 11.7052 6.66477 12.0897 6.99441 12.5831C7.32405 13.0764 7.5 13.6564 7.5 14.2498C7.5 15.0454 7.18393 15.8085 6.62132 16.3711C6.05871 16.9337 5.29565 17.2498 4.5 17.2498ZM15 6.49198L9 4.69198V1.7576L15 3.56229V6.49198Z\" fill=\"var(--fill-0, white)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/musicNote.e3b6540f2315cdfb06a3d74bacc48719.svg"),
        {
          React: SvgMusicNote,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      